import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";

import "./LO.css"; // Import the CSS file

import design from "../../assets/Images/design.png";
import advisory from "../../assets/Images/advisory.png";
import research from "../../assets/Images/research.png";
import conclusion from "../../assets/Images/conclusion.png";
import scrum from "../../assets/Images/scrum1.png";
import ethic from "../../assets/Images/ethic.png";




import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";



const LO4 = () => {
    const navigate = useNavigate();

    const cardslo4 = [
        {
            title: "Design Challange/ HMW",
            description: "",
            image: design,
            path: '/lo4/hmw'
        },

        // {
        //     title: "Summary Process",
        //     description: "",
        //     image: "",
        //     path: '/summaryprocess'
        // },

        {
            title: "Advisory Report",
            description: "",
            image: advisory,
            path: '/lo4/advisoryreport'
        },

        {
            title: "Research Question & Methods",
            description: "",
            image: research,
            path: '/lo4/research'
        },

        {
            title: "Conclusion",
            description: "",
            image: conclusion,
            path: '/lo4/conclusion'
        },

        {
            title: "Scrum & Summary Process",
            description: "",
            image: scrum,
            path: '/lo4/scrum'
        },

        {
            title: "Ethical Considerations",
            description: "",
            image: ethic,
            path: '/lo4/ethical'
        },

        
        



        
        
    ];

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Professional Standards</h1>
                {/* <p></p> */}

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
            </div>
                        
            <div className="content-lo4">
                <div className="content-lo4-card-container">
                    {cardslo4.map(({ title, description, image, path }, index) => (
                        <div 
                            key={index} 
                            className="card-lo4" 
                            onClick={() => navigate(path)} // Navigate to respective page
                        >
                            <img src={image} alt={title} className="card-lo4-image" />
                            <h3 className="card-lo4-title">{title}</h3>
                            <p className="card-lo4-description">{description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default LO4;